import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Radio, Input, message, Drawer, Breadcrumb } from 'antd';
import { FaTrash, FaPlus, FaMinus, FaShoppingCart } from 'react-icons/fa';
import MD5 from 'crypto-js/md5';
import { Link } from 'react-router-dom';
import { Api_VariavelGlobal } from '../global';

const Pdv = () => {
  const [produtos, setProdutos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [categoriaSelecionada, setCategoriaSelecionada] = useState(null);
  const [produtosFiltrados, setProdutosFiltrados] = useState([]);
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  const [userId, setUserId] = useState(localStorage.getItem('userId') || '');
  const [troco, setTroco] = useState('');
  
    // Limpar troco quando carrinho ficar vazio
    useEffect(() => {
      if (produtosSelecionados.length === 0) {
        setTroco('');
      }
    }, [produtosSelecionados]);

  useEffect(() => {
    const interval = setInterval(() => {
      const storedUserId = localStorage.getItem('userId') || '';
      if (storedUserId !== userId) {
        setUserId(storedUserId);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [userId]);

  const [pagamento, setPagamento] = useState('1'); // 1 Dinheiro, 2 Cartão, 3 Pix, 4 Ifood
  const [entrega, setEntrega] = useState('0');     // 0 Balcão, 1 Delivery, 3 Agendado
  const [frete, setFrete] = useState(0);
  const [prazoBoleto, setPrazoBoleto] = useState('');
  const [tipoCartao, setTipoCartao] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [drawerVisivel, setDrawerVisivel] = useState(false);

  // Busca global
  const [buscaGlobal, setBuscaGlobal] = useState('');

  // Subtotal / Total
  const subtotal = produtosSelecionados.reduce(
    (acc, p) => acc + Number(p.PRECO_ATUAL || 0) * Number(p.quantidade || 0),
    0
  );
  const total = Number(subtotal) + Number(parseFloat(frete || 0) || 0);

  // Troco calculado (quando pagamento = dinheiro)
  const valorTroco =
    pagamento === '1' && troco && !isNaN(parseFloat(troco))
      ? parseFloat(troco) - total
      : null;

  const abrirDrawer = () => setDrawerVisivel(true);
  const fecharDrawer = () => setDrawerVisivel(false);

  const adicionarProdutoDireto = (produto) => {
    const indexExistente = produtosSelecionados.findIndex(
      (p) => p.ID_PRODUTO === produto.ID_PRODUTO
    );

    let novosSelecionados = [...produtosSelecionados];

    if (indexExistente > -1) {
      novosSelecionados[indexExistente].quantidade =
        Number(novosSelecionados[indexExistente].quantidade || 0) + 1;
    } else {
      novosSelecionados.push({ ...produto, quantidade: 1 });
    }

    setProdutosSelecionados(novosSelecionados);
    // message.success(`Produto Adicionado +`,1);
  };

  const removerProduto = (idProduto) => {
    setProdutosSelecionados((prev) => prev.filter((p) => p.ID_PRODUTO !== idProduto));
  };

  const aumentarQuantidade = (idProduto) => {
    setProdutosSelecionados((prev) =>
      prev.map((p) =>
        p.ID_PRODUTO === idProduto ? { ...p, quantidade: Number(p.quantidade || 0) + 1 } : p
      )
    );
  };

  const diminuirQuantidade = (idProduto) => {
    setProdutosSelecionados((prev) =>
      prev
        .map((p) =>
          p.ID_PRODUTO === idProduto
            ? { ...p, quantidade: Number(p.quantidade || 0) > 1 ? Number(p.quantidade) - 1 : 1 }
            : p
        )
        .filter((p) => Number(p.quantidade || 0) > 0)
    );
  };

  // Filtra produtos quando muda categoria, produtos ou busca global
  useEffect(() => {
    let filtrados = [];

    if (buscaGlobal.trim() !== '') {
      const termo = buscaGlobal.trim().toLowerCase();
      filtrados = produtos.filter((p) => (p.PRODUTO || '').toLowerCase().includes(termo));
    } else if (categoriaSelecionada) {
      filtrados = produtos.filter(
        (p) => Number(p.ID_CATEGORIA) === Number(categoriaSelecionada)
      );
    }

    setProdutosFiltrados(filtrados);
  }, [categoriaSelecionada, produtos, buscaGlobal]);

  useEffect(() => {
    const fetchDados = async () => {
      try {
        const [catResp, prodResp] = await Promise.all([
          axios.get(`${Api_VariavelGlobal}/api/categorias/status`),
          axios.get(`${Api_VariavelGlobal}/api/produtos`),
        ]);

        setCategorias(catResp.data || []);
        setProdutos(prodResp.data || []);

        if ((catResp.data || []).length > 0) {
          setCategoriaSelecionada(catResp.data[0].ID_CATEGORIA);
        }
      } catch (error) {
        console.error('Erro ao buscar produtos ou categorias:', error);
        message.error('Erro ao carregar produtos e categorias.',1);
      }
    };
    fetchDados();
  }, []);

  // Data/hora local
  const getLocalDateTime = () => {
  const now = new Date();
  const options = {
    timeZone: "America/Belem",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  };

  // Retorna no formato "dd/mm/yyyy, hh:mm:ss"
  const formatter = new Intl.DateTimeFormat("pt-BR", options);
  const parts = formatter.formatToParts(now);

  const ano = parts.find(p => p.type === "year").value;
  const mes = parts.find(p => p.type === "month").value;
  const dia = parts.find(p => p.type === "day").value;
  const hora = parts.find(p => p.type === "hour").value;
  const minuto = parts.find(p => p.type === "minute").value;
  const segundo = parts.find(p => p.type === "second").value;

  return `${ano}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;
};


  const handleSubmitPedido = async () => {
    if (produtosSelecionados.length === 0) {
      message.error('Nenhum produto selecionado para o pedido.',1);
      return;
    }
    if (!userId) {
      message.error('Usuário não logado. Por favor, faça login antes de realizar o pedido.',1);
      return;
    }

    const token = MD5(Math.floor(Math.random() * 99999).toString()).toString();

    const pedidoData = {
      STATUS: '3',
      OBS: 'Pedido realizado via PDV',
      ENTREGA: entrega,
      PAGAMENTO: pagamento,
      PRAZO_BOLETO: prazoBoleto ? parseInt(prazoBoleto) : null,
      TIPO_CARTAO: tipoCartao || null,
      TOKEN: token,
      ID_USUARIO: userId,
      FRETE: Number(parseFloat(frete || 0) || 0).toFixed(2),
      SUBTOTAL: Number(subtotal || 0).toFixed(2),
      TOTAL: Number(total || 0).toFixed(2),
      DATA: getLocalDateTime(),
      produtos: produtosSelecionados.map((p) => ({
        produtoId: p.ID_PRODUTO,
        quantidade: Number(p.quantidade || 0),
        precoUnitario: Number(parseFloat(p.PRECO_ATUAL || 0) || 0),
      })),
      // Se quiser enviar os campos abaixo e o backend aceitar, descomente:
      // VALOR_PAGO: pagamento === '1' && troco ? Number(parseFloat(troco) || 0).toFixed(2) : null,
      // TROCO: valorTroco !== null ? Number(valorTroco).toFixed(2) : null,
    };

    try {
      setIsSubmitting(true);

      const response = await axios.post(
        `${Api_VariavelGlobal}/api/pedidos`,
        pedidoData
      );

      if (response.status === 201) {
        //message.success('Pedido realizado com sucesso!',1);
        setProdutosSelecionados([]);
        setFrete(0);
        setPrazoBoleto('');
        setTipoCartao('');
        setBuscaGlobal('');
        setTroco('');
        fecharDrawer();
      } else {
        message.error('Erro ao realizar o pedido.',1);
      }
    } catch (error) {
      console.error('Erro ao enviar pedido:', error);
      message.error(
        error.response?.data?.error || 'Erro ao enviar pedido. Verifique os dados e tente novamente.',1);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="content-wrapper">
      {/* Cabealho */}
      <h3>Pdv</h3>
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>
          <Link to="/">Início</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Pdv</Breadcrumb.Item>
      </Breadcrumb>

      {/* Botão flutuante carrinho */}
      <Button
        type="primary"
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          zIndex: 1000,
          display: produtosSelecionados.length > 0 ? 'flex' : 'none',
          alignItems: 'center',
          gap: 20,
        }}
        onClick={abrirDrawer}
      >
        <FaShoppingCart />
        Carrinho ({produtosSelecionados.length})
      </Button>

      {/* Busca global */}
      <Input.Search
        placeholder="Buscar produto..."
        allowClear
        value={buscaGlobal}
        onChange={(e) => setBuscaGlobal(e.target.value)}
        style={{ marginBottom: 12, maxWidth: 300 }}
      />

      {/* Categorias (só quando no está buscando) */}
      {buscaGlobal.trim() === '' && (
        <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
          {categorias.map((cat) => (
            <button
              key={cat.ID_CATEGORIA}
              style={{
                padding: '8px 16px',
                cursor: 'pointer',
                background:
                  Number(categoriaSelecionada) === Number(cat.ID_CATEGORIA)
                    ? '#1890ff'
                    : '#f0f0f0',
                color:
                  Number(categoriaSelecionada) === Number(cat.ID_CATEGORIA)
                    ? '#fff'
                    : '#000',
                border: 'none',
                borderRadius: 4,
              }}
              onClick={() => setCategoriaSelecionada(cat.ID_CATEGORIA)}
            >
              {cat.NOME}
            </button>
          ))}
        </div>
      )}

      <h2>Produtos</h2>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        {produtosFiltrados.length === 0 && <p>Nenhum produto encontrado.</p>}
        {produtosFiltrados.map((produto) => (
          <div
            key={produto.ID_PRODUTO}
            onClick={() => adicionarProdutoDireto(produto)}
            style={{
              width: 150,
              height: 170,
              border: '1px solid #ccc',
              borderRadius: 6,
              padding: 6,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              background: '#fff',
              cursor: 'pointer',
            }}
          >
            <img
              src={`${Api_VariavelGlobal}/api/uploads/${produto.imageUrl || ''}`}
              alt={produto.PRODUTO}
              width={150}
              height={100}
              style={{ objectFit: 'contain', marginBottom: 4 }}
            />
            <div
              style={{
                fontSize: 12,
                textAlign: 'center',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {produto.PRODUTO}
            </div>
            <strong style={{ fontSize: 22 }}>
              R$ {Number(parseFloat(produto.PRECO_ATUAL || 0) || 0).toFixed(2)}
            </strong>
          </div>
        ))}
      </div>

      {/* Drawer do carrinho */}
      <Drawer
        title={<span style={{ fontSize: 'larger', fontWeight: 'bold' }}>Produtos Selecionados</span>}
        style={{ fontSize: 'larger'}}
        placement="right"
        onClose={fecharDrawer}
        visible={drawerVisivel}              // antd v4
        // open={drawerVisivel}              // antd v5 (se estiver usando v5, troque para 'open')
        width={400}
        bodyStyle={{ padding: 20, paddingBottom: 120, overflowY: 'auto' }} // espaço pro footer fixo
        footer={(
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12, paddingTop: 20 }}>
            {/* Total sempre visvel */}
            <div style={{ textAlign: 'right', fontSize: 28, fontWeight: 'bold' }}>
              Total: R$ {Number(total || 0).toFixed(2)}
            </div>

            {/* Troco/Falta quando pagamento for dinheiro */}
            {pagamento === '1' && troco && !isNaN(parseFloat(troco)) && (
              <div
                style={{
                  textAlign: 'right',
                  fontSize: 22,
                  fontWeight: 'bold',
                  color: valorTroco >= 0 ? 'green' : 'red',
                }}
              >
                {valorTroco >= 0
                  ? `Troco: R$ ${Number(valorTroco).toFixed(2)}`
                  : `Falta R$ ${Number(Math.abs(valorTroco)).toFixed(2)}`}
              </div>
            )}

            <Button
              type="primary"
              block
              size="large"
              loading={isSubmitting}
              onClick={handleSubmitPedido}
            >
              Enviar Pedido
            </Button>
          </div>
        )}
      >
        {produtosSelecionados.length === 0 && (
          <p style={{ textAlign: 'center', color: '#999' }}>Nenhum produto selecionado.</p>
        )}

        {produtosSelecionados.map((produto) => {
          const precoUnit = Number(parseFloat(produto.PRECO_ATUAL || 0) || 0);
          const qtd = Number(produto.quantidade || 0);
          const subtotalItem = precoUnit * qtd;

          return (
            <div
              key={produto.ID_PRODUTO}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                marginBottom: 16,
                borderBottom: '1px solid #f0f0f0',
                paddingBottom: 12,
              }}
            >
              <img
                src={`${Api_VariavelGlobal}/api/uploads/${produto.imageUrl || ''}`}
                alt={produto.PRODUTO}
                width={60}
                height={60}
                style={{ borderRadius: 6, objectFit: 'contain' }}
              />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 'bold', marginBottom: 6 }}>{produto.PRODUTO}</div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                  <Button
                    size="small"
                    shape="circle"
                    icon={<FaMinus />}
                    onClick={() => diminuirQuantidade(produto.ID_PRODUTO)}
                  />
                  <span style={{ minWidth: 20, textAlign: 'center' }}>{qtd}</span>
                  <Button
                    size="small"
                    shape="circle"
                    icon={<FaPlus />}
                    onClick={() => aumentarQuantidade(produto.ID_PRODUTO)}
                  />
                </div>

                <div style={{ textAlign: 'right', color: '#555' }}>
                  Subtotal: <b>R$ {Number(subtotalItem || 0).toFixed(2)}</b>
                </div>
              </div>

              <Button
                type="text"
                icon={<FaTrash color="red" />}
                onClick={() => removerProduto(produto.ID_PRODUTO)}
              />
            </div>
          );
        })}

        {produtosSelecionados.length > 0 && (
          <>
            <div style={{ marginTop: 20 }}>
              <div style={{ textAlign: 'right', marginBottom: 10 }}>
                <b>Subtotal:</b> R$ {Number(subtotal || 0).toFixed(2)}
              </div>

              {entrega === '1' && (
                <div style={{ marginBottom: 10 }}>
                  <b>Frete:</b>
                  <Input
                    type="number"
                    value={frete}
                    onChange={(e) => setFrete(e.target.value)}
                    min={0}
                    style={{ marginTop: 4 }}
                  />
                </div>
              )}
            </div>

            <div style={{ marginTop: 30 }}>
              <b>Forma de Entrega:</b>
              <Radio.Group
                value={entrega}
                onChange={(e) => setEntrega(e.target.value)}
                style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6 }}
              >
                <Radio value="0">Venda Balcão</Radio>
                <Radio value="1">Delivery</Radio>
                <Radio value="2">Buscar na Loja</Radio>
                <Radio value="3">Agendado</Radio>
              </Radio.Group>
            </div>

            <div style={{ marginTop: 20 }}>
              <b>Forma de Pagamento:</b>
              <Radio.Group
                value={pagamento}
                onChange={(e) => setPagamento(e.target.value)}
                style={{ display: 'flex', flexDirection: 'column', gap: 4, marginTop: 6 }}
              >
                <Radio value="1">Dinheiro</Radio>
                <Radio value="2">Cartão</Radio>
                <Radio value="3">Pix</Radio>
                <Radio value="4">Ifood</Radio>
                <Radio value="5">Online</Radio>
              </Radio.Group>

              {pagamento === '1' && (
                <div style={{ marginTop: 10 }}>
                  <label>
                    <b>Troco para quanto?</b>
                  </label>
                  <Input
                    type="number"
                    placeholder="Ex: 100.00"
                    value={troco}
                    onChange={(e) => setTroco(e.target.value)}
                    style={{ marginTop: 4 }}
                  />
                </div>
              )}

              {pagamento === '2' && (
                <div style={{ marginTop: 10 }}>
                  <label>
                    <b>Tipo Cartão:</b>
                  </label>
                  <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
                    <Button
                      type={tipoCartao === 'Débito' ? 'primary' : 'default'}
                      onClick={() => setTipoCartao('Débito')}
                    >
                      Débito
                    </Button>
                    <Button
                      type={tipoCartao === 'Crédito' ? 'primary' : 'default'}
                      onClick={() => setTipoCartao('Crédito')}
                    >
                      Crdito
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </Drawer>
    </div>
  );
};

export default Pdv;
